import {Component, Input} from '@angular/core';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';

@Component({
    selector: 'app-adx-booking-support-fee-info',
    templateUrl: './adx-booking-support-fee-info.component.html',
    standalone: false
})
@AutoUnsubscribe()
export class AdxBookingSupportFeeInfoComponent {
  @Input() data: any;
  get supportFeeExtension(): any {
    return this.data ?? {};
  }
}
